//export const BASE_URI = "http://localhost:4000";
//export const API_BASE_URI = "http://localhost:4000";
//export const BUILD = "production";

export const BASE_URI = "https://harari-api.menahariya.com";
export const API_BASE_URI = "https://harari-api.menahariya.com";
export const BUILD = "production";

// export const BASE_URI = "https://dev-publicbus-api.liyubus.com";
// export const API_BASE_URI = "https://dev-publicbus-api.liyubus.com";
// export const BUILD = "production";

// export const API_BASE_URI = "https://api.sinahard.com";
// export const BASE_URI = "https://api.sinahard.com";
// export const BUILD = "development";

// export const BASE_URI = "http://196.190.220.2:3000";
// export const API_BASE_URI = "http://196.190.220.2:3000";
// export const BUILD = "production";
